/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowCDownIcon24Solid = forwardRef('ArrowCDownIcon24Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { d: "M21.058 7.44a1.5 1.5 0 0 1 0 2.12l-6.406 6.407a3.75 3.75 0 0 1-5.304 0L2.942 9.561a1.5 1.5 0 1 1 2.121-2.122l6.407 6.407a.75.75 0 0 0 1.06 0l6.407-6.407a1.5 1.5 0 0 1 2.121 0Z" })));
});
